import Icon from 'veui/components/Icon'

Icon.register({
  'file-user': {
    paths: [
      {
        d: 'M256 192a32 32 0 000 64h256a32 32 0 000-64zm64 480H160V96h448v224a32 32 0 0064 0V64a32 32 0 00-32-32H128a32 32 0 00-32 32v640a32 32 0 0032 32h192a32 32 0 000-64zm-64-320a32 32 0 000 64h160a32 32 0 000-64zm473.6 332.78a193.63 193.63 0 00-66.35-55.85 189.58 189.58 0 00-22.41-9.65 112 112 0 10-129.68 0 189.58 189.58 0 00-22.41 9.65 193.63 193.63 0 00-66.35 55.85 32 32 0 1051.17 38.44 128 128 0 01204.86 0 32 32 0 1051.17-38.44zM576 480a48 48 0 11-48 48 48.05 48.05 0 0148-48z'
      }
    ],
    width: '768',
    height: '768'
  }
})
